import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http'; 
import { MatInputModule, MatButtonModule, MatSelectModule, MatIconModule, MatFormFieldModule, MatSnackBarModule, MatDialogModule } from '@angular/material';
import { MatCardModule } from '@angular/material/card';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { RECAPTCHA_LANGUAGE } from 'ng-recaptcha';

import { AppComponent } from './app.component';
import { SubscriptionFormComponent } from './subscription-form/subscription-form.component';
import { PhoneMaskDirective } from './subscription-form/phone-mask.directive';

import { PopupComponent } from './popup/popup.component';


@NgModule({
  declarations: [
    AppComponent,
    SubscriptionFormComponent,
    PopupComponent,
    PhoneMaskDirective
  ],
  exports: [
    PhoneMaskDirective
  ],
  imports: [
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    MatInputModule, 
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    MatFormFieldModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatCardModule,
    MatCheckboxModule
  ],
  providers: [{
    provide: RECAPTCHA_SETTINGS,
    useValue: { siteKey: '6Leue0kUAAAAAPxv-r_NwS3vhpL23H2T3fIdP4Mk' } as RecaptchaSettings,
  },
  {
    provide: RECAPTCHA_LANGUAGE,
    useValue: 'pt', // use portuguese language
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
